
import { Component, computed, input } from '@angular/core'

import { IdrTableHeaderMenu } from './idr-data-table-header.component'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'app-idr-table-header-menu',
  imports: [NgbDropdownModule, MatIcon],
  template: `
    @if (menu().items.length > 0) {
      <div ngbDropdown container='body' placement='bottom-end'>
        <button ngbDropdownToggle class='menu-trigger'>
          <mat-icon [fontIcon]="dropdownIcon()" />  
        </button>
        <div ngbDropdownMenu>
          @for (i of menu().items; track i.id) {
            @if (i.separator) {
              <div class='dropdown-divider'></div>
            }
            <button ngbDropdownItem (click)="i.click()" [disabled]="i.disabled ?? false">{{ i.label }}</button>
          }
        </div>
      </div>
    }
  `,
  styles: `
    button[ngbDropdownItem] {
      &:hover {
        color: white;
        background-color: var(--active-blue);
      }
    }
    button.menu-trigger {
      border: none;
      padding: 0;
      background-color: transparent;
      &::after {
        display: none;
      }
      mat-icon {
        font-size: 18px;
        vertical-align: bottom;
      }
    }
  `,
})
export class IdrTableHeaderMenuComponent {
  readonly menu = input.required<IdrTableHeaderMenu>()
  readonly filtered = input.required<boolean>()

  protected dropdownIcon = computed(() =>
    this.filtered() ? 'filter_list' : 'arrow_drop_down',
  )
}
